import i18n from 'i18next'
import { SourceType } from 'types/SourceType'

const SOURCE_TYPE_I18N_KEYS: Record<SourceType, string> = {
    Cancellation: 'components.sourceTypes.cancellation',
    Update: 'components.sourceTypes.update',
    Stabilisation: 'components.sourceTypes.stabilisation',
    'New commitments': 'components.sourceTypes.newCommitments',
    Prospectus: 'components.sourceTypes.prospectus',
    Memorandum: 'components.sourceTypes.memorandum',
    Supplement: 'components.sourceTypes.supplement',
    Outcome: 'components.sourceTypes.outcome',
    Publication: 'components.sourceTypes.publication',
    Terms: 'components.sourceTypes.terms',
    InformationDocument: 'components.sourceTypes.informationDocument',
    Conversion: 'components.sourceTypes.conversion',
    Offset: 'components.sourceTypes.offset',
    Repayment: 'components.sourceTypes.repayment',
    PublicationWarrant: 'components.sourceTypes.publicationWarrant',
}

export const translateSourcetype = (sourceType: SourceType) => {
    const key = SOURCE_TYPE_I18N_KEYS[sourceType]
    return key ? i18n.t(key) : sourceType
}
